/* eslint-disable react/prop-types */
import { useState } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { Check, Plus, X, Trash2 } from "lucide-react"
import { useEffect } from "react"
import { API } from "./FormEdit"
import toast from "react-hot-toast"
import AddIcon from '@mui/icons-material/Add';
import { WebModal } from "./ImagesWebEditor"

const EditorContainer = styled(motion.div)`
  background-color: #2A2B2E;
  border-radius: 8px;
  padding: 20px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const FormContainer = styled.div`
  background-color: #3A3B3E;
  border-radius: 8px;
  padding: 20px;
`

const FormTitle = styled.h3`
  color: #FFFFFF;
  margin-bottom: 20px;
  font-size: 1.2rem;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  color: #FFFFFF;
  font-size: 0.9rem;
`

const Select = styled.select`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #2A2B2E;
  color: #FFFFFF;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #2A2B2E;
  color: #FFFFFF;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const TextArea = styled.textarea`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #2A2B2E;
  color: #FFFFFF;
  font-size: 1rem;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

const MultiSelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

const MultiSelectOption = styled.div`
  padding: 8px 12px;
  border-radius: 20px;
  background-color: ${(props) => (props.isSelected ? "#4A88F3" : "#2A2B2E")};
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    background-color: ${(props) => (props.isSelected ? "#3B78E0" : "#3A3B3E")};
  }
`

const ProductImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  margin-top: 10px;
`


const SizeInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`

const SizeInput = styled(Input)`
  width: 80px;
`

const SizeTag = styled.div`
  background-color: #4A88F3;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  align-items: center;
  gap: 5px;
`

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Container = styled.div`
  margin-top: 10px;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  border: 2px dashed gray;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    transform: rotate(90deg);
    border: 2px dashed #d3d3d3;
    color: #d3d3d3;
  }
`;

const PlusIcon = styled(AddIcon)`
  transition: transform 0.3s ease-in-out;
  color: gray;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
`
const ImageButton = styled.button`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: white;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`

const DeleteImageButton = styled(ImageButton)`
  top: 10px;
  right: 5px;
`


export const WebEditor = ({ products: productos }) => {
  const [doubleSliderProduct1, setDoubleSliderProduct1] = useState("")
  const [doubleSliderProduct2, setDoubleSliderProduct2] = useState("")
  const [promoComment, setPromoComment] = useState("")
  const [promoProduct, setPromoProduct] = useState("")
  const [selectedFeatures, setSelectedFeatures] = useState([])
  const [features, setFeatures] = useState([])
  const [slidertext1, setslidertext1] = useState(null)
  const [slidertext2, setslidertext2] = useState(null)
  const [products, setProducts] = useState(productos)
  const [sizes, setSizes] = useState([])
  const [tallas, setTallas] = useState([])
  const [promoDesc, setPromoDesc] = useState([])
  const [newSize, setNewSize] = useState({ height: 0, description: "" })
  const [sliderIds, setSliderIds] = useState({})
  const [isAddModalOpen ,setIsAddModalOpen] = useState(false)
  const [idModal, setIdModal] = useState(null)

  const [photosSlider1, setPhotosSlider1] = useState([])
  const [photosSlider2, setPhotosSlider2] = useState([])
  const [photoSelected, setPhotoSelected] = useState(0)
  function validateSliderText(slidertext1s, slidertext2s) {
    if (typeof slidertext1s !== 'string' || slidertext1s.length > 7) {
        return "El campo slidertext1 debe ser una cadena de texto con 6 o menos caracteres.";
    }
    if (typeof slidertext2s !== 'string' || slidertext2s.length > 7) {
        return "El campo slidertext2 debe ser una cadena de texto con 6 o menos caracteres.";
    }
    return null;
  }

  useEffect(() => {
    setProducts(productos.filter(pr => pr.status == "0"))
    fetch(`${API}/api/slider`)
    .then(data => data.json())
    .then(data => {
        const productsSlider = data.products.filter(pr => pr.assign == "slider")
        const promo = data.products.find(pr => pr.assign == "promo")
        if (productsSlider.length < 2 || promo.length < 1) {
          return
        }

        const slider1 = productsSlider.find(pr => pr.description == "1")
        const slider2 = productsSlider.find(pr => pr.description == "2")
        setSliderIds({
          slider1: slider1.id,
          slider2: slider2.id
        })

        setPhotosSlider1(slider1 ? JSON.parse(slider1.tallas) : [])
        setPhotosSlider2(slider2 ? JSON.parse(slider2.tallas) : [])

        setDoubleSliderProduct1(slider1.productoid)
        setDoubleSliderProduct2(slider2.productoid)
        setslidertext1(slider1.text)
        setslidertext2(slider2.text)
        console.log(data)
        setPromoProduct(parseInt(promo.productoid))
        setPromoComment(promo.text)
        setSizes(JSON.parse(promo.tallas))
        setPromoDesc(JSON.parse(promo.description))
    })
  }, [])

  useEffect(() => {
    if (promoProduct == 0) return setFeatures([])
    if (!promoProduct) return
    const product = products.find(pro => pro.id == promoProduct)
    if (!product) return
    const clone = structuredClone(product)
    setTallas(JSON.parse(clone.tallas))
    let clavesAEliminar = ["img", "descripcion", "id", "status", "colores", "fecha", "updatedAt", "createdAt", "color", "tallas", "nombre"];
    clavesAEliminar.forEach(clave => delete clone[clave]);
    let keys = Object.entries(clone)
    setFeatures(keys)
    promoDesc.forEach(pro => {
    handleFeatureToggle(pro)
    })
  }, [promoProduct])


  const handleFeatureToggle = (feature) => {
    setSelectedFeatures((prev) =>
      isFeatureActive(feature) ? prev.filter((f) => f[0] !== feature[0]) : prev.length < 4 ? [...prev, feature] : prev,
    )
  }

  const handleDoubleSliderSubmit = (e) => {
    e.preventDefault()
    const validate = validateSliderText(slidertext1, slidertext2)
    if (validate) return toast.error(validate)

    console.log("Double Slider actualizado:", { doubleSliderProduct1, doubleSliderProduct2 })
    fetch(`${API}/api/slider/slider`, {
      method: "POST",
      body: JSON.stringify({ product1: doubleSliderProduct1, product2: doubleSliderProduct2, text1: slidertext1, text2: slidertext2, ...sliderIds }),
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(data => data.json())
    .then(data => {
      toast.success("Slider actualizado con éxito")
      console.log(data)
    })
  }

  const handlePromoSubmit = (e) => {
    e.preventDefault()
    console.log("Promoción actualizada:", { promoComment, promoProduct, selectedFeatures, sizes })
    if (promoComment.length <= 10) return toast.error("El comentario debe ser mas largo")
    if (selectedFeatures.length < 4) return toast.error("Seleccione 4 caracteristicas como minimo") 
    fetch(`${API}/api/slider/promo`, {
        method: "POST",
        body: JSON.stringify({
          text: promoComment,
          productoid: promoProduct,
          description: JSON.stringify(selectedFeatures),
          tallas: JSON.stringify(sizes)
        }),
        headers: {
          "Content-Type": "application/json"
        }
    })
    .then(data => data.json())
    .then(data => {
      console.log(data)
      if (data.error) toast.error(data.error)
      toast.success("Promoción actualizada con éxito")
    })
    // Aquí iría la lógica para actualizar la promoción en la web
  }

  const handleAddSize = () => {
    if (newSize.height > 0 && newSize.description) {
      setSizes([...sizes, newSize])
      setNewSize({ height: 0, description: "" })
    }
  }

  const handleRemoveSize = (index) => {
    setSizes(sizes.filter((_, i) =>     i !== index))
  }

  function isFeatureActive(featu){
    let active = false
    selectedFeatures.forEach(f => {
      if (f[0] == featu[0]) active = true
    })
    return active
  }
  
  function openModal(lado, id){
    setIdModal(lado)
    setPhotoSelected(id)
    setIsAddModalOpen(true)
  }
  function deleteImage(lado, id){
    let slider
    if (lado == 1) slider = sliderIds.slider1
    if (lado == 2) slider = sliderIds.slider2

    fetch(`${API}/api/slider/image`,{
      method: "DELETE",
      body: JSON.stringify({
        sliderid: slider,
        id: id
      }),
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(data => data.json())
    .then(data => { 
      if (data.error) return console.log(data.error)
      const imagesFilters = lado == 1
      ? photosSlider1.filter(img => img.id != id)
      : photosSlider2.filter(img => img.id != id)

      if (lado == 1) setPhotosSlider1(imagesFilters)
      else setPhotosSlider2(imagesFilters)
      toast.success("Imagen eliminada con éxito")
    })
  }

  function addImage({ image }){
    if (image.color == "") return toast.error("seleccione un color")
    if (image.url == "" || null) return toast.error("seleccione una imagen")
    const formData = new FormData();
    formData.append('file', image.url);
    formData.append('id', idModal);
    formData.append('color', image.color);
    formData.append('operation', "create");
    fetch(`${API}/api/slider/image`, {
      method: "POST",
      body: formData
    })
    .then(data => data.json())
    .then(data => {
      console.log(data)
      setIsAddModalOpen(false)
      if (photoSelected == 1)     setPhotosSlider1((prevPhotos) => {
        console.log(prevPhotos)
        // `prevPhotos` es el estado anterior
        return [...prevPhotos, data.image];
    })
    else   setPhotosSlider2((prevPhotos) => {
      // `prevPhotos` es el estado anterior
      console.log(prevPhotos)
      return [...prevPhotos, data.image];
  });
  toast.success("Imagen agregada con éxito")

  
    })
  }
  return (
    <EditorContainer initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
       
      {isAddModalOpen &&
        <WebModal setIsAddModalOpen={setIsAddModalOpen} onAddImage={addImage}/>
      }
      <FormContainer>
        <FormTitle>Personalizar Double Slider</FormTitle>
        <Form onSubmit={handleDoubleSliderSubmit}>
        <FormGroup>
            <Label htmlFor="promoComment">Boton primer producto</Label>
            <Input
              id="btn1"
              value={slidertext1}
              onChange={(e) => setslidertext1(e.target.value)}
              placeholder="Introduce el texto del boton"
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="product1">Primer Producto</Label>
            <Select
              id="product1"
              value={doubleSliderProduct1}
              onChange={(e) => setDoubleSliderProduct1(e.target.value)}
            >
              <option value="">Selecciona un producto</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.nombre}
                </option>
              ))}
            </Select>
            {doubleSliderProduct1 &&
             <div style={{ display: "flex", gap: 10}}>
          {photosSlider1.map(photo => (
            <ImageWrapper key={photo.id}>
            <ProductImage src={photo.url.secure_url} />
            <DeleteImageButton aria-label="Eliminar imagen"  type="button" onClick={() => {
              deleteImage(1, photo.id)
              }}>
              <Trash2 size={14} />
            </DeleteImageButton>
            </ImageWrapper>
            ))
            }


              <Container onClick={() => openModal(sliderIds.slider1, 1)}>
               <PlusIcon className="plus-icon" fontSize="large" />
              </Container>
              </div>
              }
          </FormGroup>

          <FormGroup>
            <Label htmlFor="promoComment">Boton segundo producto</Label>
            <Input
              id="btn2"
              value={slidertext2}
              onChange={(e) => setslidertext2(e.target.value)}
              placeholder="Introduce el texto del boton"
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="product2">Segundo Producto</Label>
            <Select
              id="product2"
              value={doubleSliderProduct2}
              onChange={(e) => setDoubleSliderProduct2(e.target.value)}
            >
              <option value="">Selecciona un producto</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.nombre}
                </option>
              ))}
            </Select>
            {doubleSliderProduct2 && 
             <div style={{ display: "flex", gap: 10}}>
            {photosSlider2.map(photo => (
            <ImageWrapper key={photo.id}>
            <ProductImage src={photo.url.secure_url} />
            <DeleteImageButton aria-label="Eliminar imagen"  type="button" onClick={() => {
              deleteImage(2, photo.id)
              }}>
              <Trash2 size={14} />
            </DeleteImageButton>
            </ImageWrapper>
            ))
            }

              <Container onClick={() => openModal(sliderIds.slider2, 2)} >
               <PlusIcon className="plus-icon" fontSize="large" />
              </Container>
              </div>
              }
          </FormGroup>
          <Button type="submit">Actualizar Double Slider</Button>
        </Form>
      </FormContainer>

      <FormContainer>
        <FormTitle>Configurar Promoción</FormTitle>
        <Form onSubmit={handlePromoSubmit}>
          <FormGroup>
            <Label htmlFor="promoComment">Comentario de Promoción</Label>
            <Input
              id="promoComment"
              value={promoComment}
              onChange={(e) => setPromoComment(e.target.value)}
              placeholder="Introduce el comentario de promoción"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="promoProduct">Producto de Primicia</Label>
            <Select id="promoProduct" value={promoProduct} onChange={(e) => setPromoProduct(e.target.value)} placeholder="Seleccione un producto">
              <option value="">Selecciona un producto</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.nombre}
                </option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Características a mostrar (selecciona 4)</Label>
            <MultiSelectContainer>
              {features?.map((feature) => (
                <MultiSelectOption
                  key={feature}
                  isSelected={isFeatureActive(feature)}
                  onClick={() => handleFeatureToggle(feature)}
                >
                  {feature[0]}
                  {isFeatureActive(feature) && <Check size={16} />}
                </MultiSelectOption>
              ))}
            </MultiSelectContainer>
          </FormGroup>

          <FormGroup>
            <Label>Tallas</Label>
            <div  style={{display: "flex", gap: 5}}>
            {sizes.map((size, index) => (

              <SizeTag key={index}>
                <div style={{display: "flex", gap: 5}}>
                {size.height} - {size.description}
                <RemoveButton onClick={() => handleRemoveSize(index)}>
                  <X size={16} />
                </RemoveButton>
                </div>
              </SizeTag>              
            ))}
            </div>
            <SizeInputGroup>
              <SizeInput
                type="number"
                value={newSize.height || ""}
                onChange={(e) => setNewSize({ ...newSize, height: Number.parseInt(e.target.value) })}
                placeholder="Altura"
              />
              <Select
              id="product1"
              value={newSize.description || ""}
              onChange={(e) => setNewSize({ ...newSize, description: e.target.value })}
            >
              <option value="">Selecciona una talla</option>
              {tallas.map((talla, index) => (
                <option key={index} value={talla.name}>
                  {talla.name}
                </option>
              ))}
            </Select>
              <Button type="button" onClick={handleAddSize}>
                <Plus size={16} />
              </Button>
            </SizeInputGroup>
          </FormGroup>

          <Button type="submit">Actualizar Promoción</Button>
        </Form>
      </FormContainer>
    </EditorContainer>
  )
}

